@if (selectedCount > 0) {
  <div class="action-bar" [class.action-bar-default]="type === 'default'" [class.action-bar-download]="type === 'download'">
    
    <!-- 📌 TYPE: DEFAULT (Editar/Eliminar) -->
    @if (type === 'default') {
      <div class="action-bar-content">
        <app-button
          [label]="'common.actions.delete' | transloco"
          variant="secondary"
          (onClick)="handleDelete()">
        </app-button>

        @if (showEditButton) {
          <app-button
            [label]="'common.actions.edit' | transloco"
            variant="secondary"
            (onClick)="handleEdit()">
          </app-button>
        }
      </div>
    }

    <!-- 📌 TYPE: DOWNLOAD (Descargar/Eliminar/Cancelar) -->
    @if (type === 'download') {
      <div class="action-bar-content action-bar-download-content">
        <div class="action-bar-left">
          <app-button
            icon="Download"
            variant="icon-ghost"
            [ariaLabel]="'common.a11y.download' | transloco"
            (onClick)="handleDownload()">
          </app-button>

          <div class="divider"></div>

          <app-button
            icon="Trash"
            [label]="'common.actions.delete' | transloco"
            variant="ghost"
            class="delete-btn"
            (onClick)="handleDelete()">
          </app-button>
        </div>

        <app-button
          [label]="'common.actions.cancel' | transloco"
          variant="ghost"
          (onClick)="handleCancel()">
        </app-button>
      </div>
    }

  </div>
}
